module.exports = __webpack_public_path__ + "img/g10.ef0930e7.jpg";